import type { Job } from '#shared/types/Job'
import type { Project } from '#shared/types/Project'
import type { Skill } from '#shared/types/Skill'
import type { UserProfile } from '#shared/types/User'

/**
 * Type definition for homepage featured data
 */
export type HomepageFeaturedData = {
    jobs?: { items: Job[]; count: number }
    projects?: { items: Project[]; count: number }
    mentors?: { items: UserProfile[]; count: number }
    skills?: { items: Skill[]; count: number }
    governmentJobs?: { items: Job[]; count: number }
    studentJobs?: { items: Job[]; count: number }
}

/**
 * Composable for main site-wide functionality
 */
export function useMain() {
    const { $api } = useNuxtApp()

    /**
     * Load featured data for homepage
     */
    const loadFeaturedData = async (): Promise<HomepageFeaturedData> => {
        try {
            const response = await $api.get('/homepage-featured')
            return response.data
        } catch (error) {
            console.error('Error loading featured data:', error)
            return {}
        }
    }

    /**
     * Load data for Slovaks Abroad page
     */
    const loadSlovaksAbroadData = async () => {
        try {
            return await $api.get('/slovaks-abroad-featured').then((response) => response.data)
        } catch (error) {
            console.error('Error loading Slovaks Abroad data:', error)
            return { jobs: { items: [], count: 0 } }
        }
    }

    /**
     * Load data for Want to be Volunteer page
     */
    const loadWantToBeVolunteerData = async () => {
        try {
            return await $api.get('/want-to-be-volunteer-featured').then((response) => response.data)
        } catch (error) {
            console.error('Error loading Want to be Volunteer data:', error)
            return { projects: { items: [], count: 0 } }
        }
    }

    return {
        loadFeaturedData,
        loadSlovaksAbroadData,
        loadWantToBeVolunteerData
    }
}
